import React  from 'react';
import Words from '../../components/words';

import './style.css';  //  !!!

const PageWithWords = ({ onNextLevel, messNext, answer, setAnswer, props } ) => {

  return ( 
		<Words onNextLevel={onNextLevel} messNext={messNext} answer={answer} setAnswer={setAnswer} words={props} />
    );
}   

export default PageWithWords;
